import acceptedCookiePolicy from "../../../components/onetrust/cookiePolicy";
import logAmplitudeEvent from "../../../components/amplitude";

const logLinkClicks = (anchor_text = "", destination_link = "", interaction_location = "", interaction_page = "", navigational = "false") => {
    logAmplitudeEvent({
        event_type: "Link Clicked",
        properties: {
            anchor_text: anchor_text,
            destination_link: destination_link,
            interaction_location: interaction_location,
            interaction_page: interaction_page,
            navigational: navigational
        }
    });
}

const logLinkCopied = (anchor_text = "", destination_link = "", interaction_location = "", interaction_page = "", navigational = "false") => {
    logAmplitudeEvent({
        event_type: "Link Copied",
        properties: {
            anchor_text: anchor_text,
            destination_link: destination_link,
            interaction_location: interaction_location,
            interaction_page: interaction_page,
            navigational: navigational
        }
    });
}

const logLinkClickInteractions = (event) => {
    let link = '';
    let closestA = event.target.closest('a');
    let closestButton = event.target.closest('button');
    let isItNavigationalLink = '';


    link = closestA ? closestA : closestButton ? closestButton : '';

    acceptedCookiePolicy({
        ifPerformanceCookies: () => {
            if (OnetrustActiveGroups.includes("C0004")) {
                if (link) {
                    let interactionLocation = '';
                    let dataTracking = 'None';
                    let text = 'No_text';

                    if (link.dataset.tracking !== '') {
                        dataTracking = link.dataset.tracking;
                    }

                    if (link.closest('[data-vue-component]')) {
                        interactionLocation = link.closest('[data-vue-component]');
                        interactionLocation = interactionLocation.dataset.vueComponent.split('/').pop();

                    } else if (link.closest('[data-component-file]')) {
                        interactionLocation = link.closest('[data-component-file]');
                        interactionLocation = interactionLocation.dataset.componentFile.split('/').pop().replace('.main', '');

                    } else if (link.closest('[id]')) {
                        interactionLocation = link.closest('[id]')?.id;

                    } else if (link.closest('.main > div')) {
                        const parentElement = link.closest('.main > div');
                        const attributes = parentElement.getAttributeNames();

                        interactionLocation = attributes.find(attribute => attribute.startsWith('am-') && attribute !== 'am-color-scheme');
                    }

                    if (link.innerText) {
                        text = link.innerText.replace(/(\r\n|\n|\r)/gm, '').trim();
                        text = text.split(' ').join('_');
                        text = `CTA_${text}`;
                    }

                    if (interactionLocation && interactionLocation.includes('main-nav')) {
                        isItNavigationalLink = "true";
                    }


                    let anchor_text = link.innerText.replace(/(\r\n|\n|\r)/gm, '').trim() || null;
                    let destination_link = link?.href || null;
                    let interaction_location = interactionLocation || null;
                    let interaction_page = window.location.href.split("?")[0] || null;
                    let navigational = isItNavigationalLink || null;

                    logLinkClicks(anchor_text, destination_link, interaction_location, interaction_page, navigational);

                }
            }
        }
    });

}

const logLinkCopyInteractions = (event) => {
    let link = '';
    let closestA = event.target.closest('a');
    let closestButton = event.target.closest('button');
    let isItNavigationalLink = '';


    link = closestA ? closestA : closestButton ? closestButton : '';

    acceptedCookiePolicy({
        ifPerformanceCookies: () => {
            if (OnetrustActiveGroups.includes("C0004")) {
                if (link) {
                    let interactionLocation = '';
                    let dataTracking = 'None';
                    let text = 'No_text';

                    if (link.dataset.tracking !== '') {
                        dataTracking = link.dataset.tracking;
                    }

                    if (link.closest('[data-vue-component]')) {
                        interactionLocation = link.closest('[data-vue-component]');
                        interactionLocation = interactionLocation.dataset.vueComponent.split('/').pop();

                    } else if (link.closest('[data-component-file]')) {
                        interactionLocation = link.closest('[data-component-file]');
                        interactionLocation = interactionLocation.dataset.componentFile.split('/').pop().replace('.main', '');

                    } else if (link.closest('[id]')) {
                        interactionLocation = link.closest('[id]')?.id;

                    } else if (link.closest('.main > div')) {
                        const parentElement = link.closest('.main > div');
                        const attributes = parentElement.getAttributeNames();

                        interactionLocation = attributes.find(attribute => attribute.startsWith('am-') && attribute !== 'am-color-scheme');
                    }

                    if (link.innerText) {
                        text = link.innerText.replace(/(\r\n|\n|\r)/gm, '').trim();
                        text = text.split(' ').join('_');
                        text = `CTA_${text}`;
                    }

                    if (interactionLocation.includes('main-nav')) {
                        isItNavigationalLink = "true";
                    }


                    let anchor_text = link.innerText.replace(/(\r\n|\n|\r)/gm, '').trim() || null;
                    let destination_link = link?.href || null;
                    let interaction_location = interactionLocation || null;
                    let interaction_page = window.location.href.split("?")[0] || null;
                    let navigational = isItNavigationalLink || null;

                    logLinkCopied(anchor_text, destination_link, interaction_location, interaction_page, navigational);

                }
            }
        }
    });

}

const amplitudeCtaGlobal = () => {
    document.addEventListener('mousedown', logLinkClickInteractions);
    document.addEventListener('touchstart', logLinkClickInteractions);
    document.addEventListener("copy", logLinkCopyInteractions)
}

export default amplitudeCtaGlobal;